import React, { useEffect, useState } from "react";

import { Affix, Button, Layout, Typography, Spin, Space } from "antd";
import {
  ArrowUpOutlined,
  // LeftCircleOutlined,
  // RightCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Content, Header } from "antd/es/layout/layout";
import { fetchTermsCondition } from "../../redux/common/common.actions";
import { useDispatch } from "react-redux";
import { LeftCircleOutlined, CopyrightOutlined } from "@ant-design/icons";
import { ReactComponent as LogoITCTradeNext } from "../../assets/itc_trade_next_logo.svg";
import router from "../../components/History/index.component";
import { useSelector } from "react-redux";

const TermsandConditions: React.FC = () => {
  // const [numPages, setNumPages] = useState(null);
  // const [pageNumber, setPageNumber] = useState(1);
  // const [showTopBtn, setShowTopBtn] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const dispatch = useDispatch();
  const isLogged = useSelector((state: any) => state.user.isLogged);

  // function onDocumentLoadSuccess({ numPages }) {
    // setNumPages(numPages);
    // setPageNumber(1);
  // }

  useEffect(() => {
    getTermsCondition();
    // window.addEventListener("scroll", () => {
    //   if (window.scrollY > 100) {
    //     setShowTopBtn(true);
    //   } else {
    //     setShowTopBtn(false);
    //   }
    // });
  }, []);

  const getTermsCondition = async () => {
    const data = await dispatch(fetchTermsCondition());
    data && setHtmlContent(data);
  };
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <Layout style={{ display: "flex", justifyContent: "center" }}>
      {!isLogged && (
        <Header
          style={{
            position: "fixed",
            top: 0,
            // zIndex: 1,
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <div>
            <LeftCircleOutlined
              style={{
                color: "#faad14",
                cursor: "pointer",
                fontSize: "xx-large",
                position: "fixed",
                left: 12,
                top: 14,
              }}
              onClick={() => {
                router.navigate("/signin");
              }}
            />
            <LogoITCTradeNext
              style={{
                width: "20em",
                cursor: "pointer",
              }}
              onClick={() => {
                router.navigate("/signin");
              }}
            />
          </div>
        </Header>
      )}
      {/* {showTopBtn && (
        <Affix
          offsetBottom={30}
          style={{ position: "absolute", bottom: 0, zIndex: 1 }}
        >
          <Button type="primary" onClick={goToTop}>
            <ArrowUpOutlined />
            Top
          </Button>
        </Affix>
      )} */}
      {/* {numPages && (
        <Affix offsetTop={30} style={{ position: "absolute", top: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: "1em",
              backgroundColor: "#ffffff",
              justifyContent: "space-between",
            }}
          >
            <Button
              shape="circle"
              disabled={numPages ? pageNumber === 1 : true}
              type="default"
              onClick={() =>
                setPageNumber((prevPageNumber) => prevPageNumber - 1)
              }
            >
              <LeftCircleOutlined />
            </Button>
            <Typography.Text strong>
              Page {pageNumber} of {numPages}
            </Typography.Text>
            <Button
              shape="circle"
              disabled={numPages ? pageNumber === numPages : true}
              type="default"
              onClick={() =>
                setPageNumber((prevPageNumber) => prevPageNumber + 1)
              }
            >
              <RightCircleOutlined />
            </Button>
          </div>
        </Affix>
      )} */}
      <div
        style={{
          overflow: "scroll",
          overflowY: "hidden",
          overflowX: "hidden",
        }}
      >
        {/* <Document
          file="./ABD_Terms_Conditions.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          loading={
            <Space
              direction="horizontal"
              size={10}
              style={{ height: "80vh", margin: "auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
              <Typography.Text strong>Please Wait...</Typography.Text>
            </Space>
          }
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              scale={1.5}
            />
          ))}
        </Document> */}
        <Content style={{ padding: "50px", marginTop: 20 }}>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </Content>
      </div>
    </Layout>
  );
};

export default TermsandConditions;
